export interface ILanguage {
    label: string,
	value: string,
	form?: any
}

export const langArr: ILanguage[] = [
    { label: 'English', value: 'en', form: [] },
    { label: 'Hindi', value: 'hi', form: [] },
];